export default "__VITE_ASSET__BmAqyW45__"